import { Box, Collapse, Alert, IconButton, AlertTitle } from "@mui/material";
import Close from '@mui/icons-material/Close';


const CallAlertBar = ({ parentRollMsgOpen, setParentRollMsgOpen, parentRollSeverityvalue, setParentRollSeverityvalue, parentRollAlertTitleValue, setParentRollAlertTitleValue, parentRollMessageValue, setParentRollMessageValue }) => {
    return (
        <Box sx={{ width: '100%' }}>
            {/* ,padding:"5px" */}
            <Collapse in={parentRollMsgOpen}>
                <Alert severity={parentRollSeverityvalue}
                    action={
                        <IconButton
                            onClick={() => {
                                setParentRollMsgOpen(false);
                            }}
                        >
                            <Close fontSize="inherit" />
                        </IconButton>                    }
                    
                >
                    <AlertTitle>{parentRollAlertTitleValue}</AlertTitle>
                    {/* {parentRollMessageValue} */}
                    {/* Render the validation messages as a list */}
                    <ul>
                        {parentRollMessageValue.split('\n').map((msg, index) => (
                            // Use index as key if no unique identifier is available
                            <li key={index}>{msg}</li>
                        ))}
                    </ul>
                </Alert>
            </Collapse>
        </Box>

    );

};
export default CallAlertBar;




// import { Box, Collapse, Alert, IconButton, AlertTitle, alpha, useTheme } from "@mui/material";
// import CloseIcon from '@mui/icons-material/Close';
// import { tokens } from "../theme/theme";

// const CallAlertBar = ({ 
//   parentRollMsgOpen, 
//   setParentRollMsgOpen, 
//   parentRollSeverityvalue, 
//   parentRollAlertTitleValue, 
//   parentRollMessageValue,
 
// }) => {
//   const theme = useTheme();
//   const colors = tokens(theme.palette.mode);
//   const severityStyles = {
//     error: {
//       bgcolor: alpha(colors.redAccent?.[400] || '#f44336', 0.15),
//       borderColor: colors.redAccent?.[400] || '#f44336',
//       iconColor: colors.redAccent?.[500] || '#d32f2f',
//       titleColor: colors.redAccent?.[600] || '#b71c1c'
//     },
//     warning: {
//       bgcolor: alpha(colors.orangeAccent?.[400] || '#ff9800', 0.15),
//       borderColor: colors.orangeAccent?.[400] || '#ff9800',
//       iconColor: colors.orangeAccent?.[500] || '#f57c00',
//       titleColor: colors.orangeAccent?.[600] || '#e65100'
//     },
//     success: {
//       bgcolor: alpha(colors.greenAccent?.[400] || '#4caf50', 0.15),
//       borderColor: colors.greenAccent?.[400] || '#4caf50',
//       iconColor: colors.greenAccent?.[500] || '#388e3c',
//       titleColor: colors.greenAccent?.[600] || '#2e7d32'
//     },
//     info: {
//       bgcolor: alpha(colors.primary?.[400] || '#2196f3', 0.15),
//       borderColor: colors.primary?.[400] || '#2196f3',
//       iconColor: colors.primary?.[500] || '#1976d2',
//       titleColor: colors.primary?.[600] || '#1565c0'
//     }
//   };

//   const style = severityStyles[parentRollSeverityvalue] || severityStyles.info;

//   return (
//     <Box sx={{ width: '100%', mb: 2 }}>
//       <Collapse in={parentRollMsgOpen}>
//         <Alert 
//           severity={parentRollSeverityvalue}
//           sx={{
//             borderRadius: 2.5,
//             border: `1px solid ${style.borderColor}`,
//             bgcolor: style.bgcolor,
//             backdropFilter: 'blur(12px)',
//             boxShadow: `0 8px 32px ${alpha(style.iconColor, 0.25)}`,
//             '& .MuiAlert-icon': {
//               color: style.iconColor,
//               fontSize: '1.25rem'
//             },
//             '& .MuiAlert-message': {
//               padding: '16px 20px',
//               color: colors?.grey?.[100] || '#f5f5f5'
//             },
//             '&:hover': {
//               boxShadow: `0 12px 40px ${alpha(style.iconColor, 0.35)}`,
//               transform: 'translateY(-1px)',
//               transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
//             }
//           }}
//           action={
//             <IconButton
//               aria-label="close"
//               color="inherit"
//               size="small"
//               onClick={() => setParentRollMsgOpen(false)}
//               sx={{
//                 color: style.iconColor,
//                 '&:hover': {
//                   bgcolor: alpha(style.iconColor, 0.15),
//                   transform: 'scale(1.1)'
//                 }
//               }}
//             >
//               <CloseIcon fontSize="small" />
//             </IconButton>
//           }
//         >
//           <AlertTitle 
//             sx={{ 
//               fontWeight: 700, 
//               fontSize: '1rem',
//               color: style.titleColor,
//               mb: 1,
//               display: 'flex',
//               alignItems: 'center',
//               gap: 1
//             }}
//           >
//             {parentRollAlertTitleValue}
//           </AlertTitle>
          
//           {/* Styled message list */}
//           <Box sx={{ 
//             pl: 2,
//             '& ul': {
//               margin: 0,
//               padding: 0,
//               listStyle: 'none',
//               '& li': {
//                 fontSize: '0.875rem',
//                 lineHeight: 1.5,
//                 color: colors?.grey?.[200] || '#e0e0e0',
//                 position: 'relative',
//                 pb: 0.5,
//                 '&::before': {
//                   content: '""',
//                   position: 'absolute',
//                   left: -12,
//                   top: 4,
//                   width: 4,
//                   height: 4,
//                   borderRadius: '50%',
//                   bgcolor: alpha(style.iconColor, 0.6)
//                 }
//               }
//             }
//           }}>
//             <ul>
//               {parentRollMessageValue.split('\n').filter(msg => msg.trim()).map((msg, index) => (
//                 <li key={index}>{msg.trim()}</li>
//               ))}
//             </ul>
//           </Box>
//         </Alert>
//       </Collapse>
//     </Box>
//   );
// };

// export default CallAlertBar;
